import YInput from './src/main'

YInput.install = function(Vue) {
  Vue.component(YInput.name, YInput)
}

export default YInput
